// normalize fuel type
export const normalizeFuelType = (fuelType: string | null | undefined): string | null => {
    if (!fuelType) return null;

    const clean = fuelType
        .toLocaleLowerCase("tr")
        .trim()
        .replace(/\s+/g, " "); // gereksiz boşlukları temizle

    // Haritalama tablosu: TypeScript'te anahtarların string, değerlerin string olduğunu belirtmek için Record kullanıyoruz
    const map: Record<string, string> = {
        benzin: "benzin",
        benzinli: "benzin",
        benzın: "benzin",
        benzınlı: "benzin",
        lpg: "benzin_lpg",
        dizel: "dizel",
        diesel: "dizel",
        dızel: "dizel",
        elektrik: "elektrik",
        elektrikli: "elektrik",
        hibrit: "hibrit",
        hybrid: "hibrit",
    };

    // eşleşme ara
    return map[clean] || null;
};

export const formatDate = (dateString: string | number | Date | null | undefined): string => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    // TypeScript'te geçerli bir tarih olup olmadığını kontrol etmenin en güvenli yolu getTime() kullanmaktır
    if (isNaN(date.getTime())) return "-";

    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    };

    return date.toLocaleDateString('tr-TR', options);
};

export function formatPhoneNumber(phone: string) {
    const cleaned = phone.replace(/\D/g, "");
    if (cleaned.startsWith("5") && cleaned.length === 10) {
        return `90${cleaned}`;
    }
    return cleaned;
}